import React from 'react'
import { Typography, Button } from '@weirgroup/weir-dls'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useDarkMode } from '../../hooks/use-darkmode'
import { useAnalyticsEvent } from '../../hooks/useAnalyticsEvent'
import { routePath } from '../../constants/navigation.constants'
import './styles.scss'

export const AddBulkAsset = () => {
    const { t } = useTranslation()
    const { darkMode } = useDarkMode()
    const navigate = useNavigate()
    const logAnalyticsEvent = useAnalyticsEvent()

    useEffect(() => {
        logAnalyticsEvent('user_viewed_add_bulk_asset_page', { description: 'User viewed add bulk asset page' });
    }, []);

        // This file has been removed as single asset creation is no longer supported.

    const handleBulkCreation = () => {
        navigate(routePath.UPLOAD_ASSETS)
    }

    return (
        <div className={`add-bulk-asset-container ${darkMode ? 'dark-mode' : ''}`}>
            <div className="create-assets-modal">
                <div className="modal-header">
                    <Typography
                        variant="H3"
                        color={darkMode ? "white" : "black"}
                    >
                        {t('addBulkAsset.title')}
                    </Typography>
                </div>
                
                <div className={`modal-content ${darkMode ? 'dark-mode' : ''}`}>
                    <Typography
                        variant="P1"
                        component="p"
                        color={darkMode ? "white" : "black"}
                    >
                        {t('addBulkAsset.subtitle')}
                    </Typography>

                    <div className="asset-creation-options">
                        {/* Single asset creation option removed */}

                        <div className="option-card">
                            <Typography
                                variant="P1"
                                component="h3"
                                className="option-title"
                                color={darkMode ? "white" : "black"}
                            >
                                {t('addBulkAsset.options.bulkCreation')}
                            </Typography>
                            <div className="button-container">
                                <Button
                                    darkMode={darkMode}
                                    label={t('addBulkAsset.buttons.upload')}
                                    size="md"
                                    variant="primary"
                                    onClick={handleBulkCreation}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddBulkAsset
